"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var React = __importStar(require("react"));
var useOutsideClickNotifier_1 = require("../../library/hooks/useOutsideClickNotifier");
var propsFilter_1 = require("../../library/propsFilter");
var SharkMorphContext_1 = require("../../providers/SharkMorphContext");
require("./popover.css");
var body = document.getElementsByTagName('body')[0];
/**
 *
 * @use ActivatorPopover
 * @use ContentPopover
 *
 * Popover is meant to be used with them
 */
var Popover = function (_a) {
    var children = _a.children, _b = _a.hoverable, hoverable = _b === void 0 ? false : _b, _c = _a.open, open = _c === void 0 ? false : _c, onClickOutside = _a.onClickOutside, elementRefAppendEventListener = _a.appendClickListenerToElementRef, props = __rest(_a, ["children", "hoverable", "open", "onClickOutside", "appendClickListenerToElementRef"]);
    var ref = React.useRef(null);
    (0, useOutsideClickNotifier_1.useOutsideClickNotifier)(ref, open ? 'watch' : 'idle', onClickOutside, elementRefAppendEventListener);
    React.useEffect(function () {
        setOverflow();
    });
    var findChild = function () {
        return Array.isArray(children)
            ? children.filter(function (e) { return e.props.theme === 'fullscreen'; })
                .length !== 0
            : children.props.theme === 'fullscreen';
    };
    var setOverflow = function () {
        if (findChild() && open) {
            return (body.style.overflow = 'hidden');
        }
        if (body.dataset.modalIsOpen === undefined) {
            return (body.style.overflow = 'auto');
        }
        return;
    };
    var setClassnames = function () { return ({
        hoverable: hoverable !== null && hoverable !== void 0 ? hoverable : false,
        open: open !== null && open !== void 0 ? open : false,
    }); };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ ref: ref }, (0, propsFilter_1.getAllDataProps)(props, (0, SharkMorphContext_1.useSharkMorphContext)()), { className: (0, clsx_1.default)('popover', setClassnames()) }, { children: children })));
};
exports.Popover = Popover;
//# sourceMappingURL=Popover.js.map